import { Box, Grid, Typography, useMediaQuery, Card, CardContent } from '@mui/material'
import React from 'react'
import PropTypes from 'prop-types'

const PreviewTile = ({ title, text, id }) => {
    return (
        <Grid item xs={4} md={3} key={title} id={id}>
            <Card variant="outlined" >
                <CardContent>
                    <Typography variant="h6" color="textSecondary">
                        {title}
                    </Typography>
                    <Typography variant="h4">{text}</Typography>
                </CardContent>
            </Card>
        </Grid>
    )
}

PreviewTile.propTypes = {
    text: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
}

export default PreviewTile
